import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IClassForTable } from "../../models/Class";
import { ClassService } from "../../services/class.service";
import { ClassCategoryService } from "../../services/class-category.service";
import { IClassCategory } from "../../models/ClassCategory";

export const useGetAllClassesCategoriesQuery = (searchValue: string | null) => {
  return useQuery<IClassCategory[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_CLASSES_CATEGORIES, searchValue],
    queryFn: () =>
      ClassCategoryService.getAllClassesCategories(searchValue).then((res) => res.data),
  });
};
